import React from 'react';
import PropTypes from 'prop-types';
import { ApIcon } from '@alixpartners/ui-components';
import { white } from 'styles/colors';
import {
	ErrorTable,
	FileSummary,
	FileItem,
	FlexAlighRight,
	FileList,
	FileListWrapper,
	ImageWrapper,
	DownloadBtn,
	HeaderRow,
	HeaderLabel,
	HeaderValue,
	HeaderHelper,
} from './styles';

const ErrorList = props => {
	const { errors, fileSize, fileName, rowsWithErrors } = props;

	const downloadLog = () => {
		const element = document.createElement('a');
		element.setAttribute(
			'href',
			'data:text/plain;charset=utf-8,' + encodeURIComponent(errors.join('\n'))
		);
		element.setAttribute('download', 'SpendCubeErrorsLog.txt');
		element.style.display = 'none';
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	};

	return (
		<ErrorTable>
			<HeaderRow>
				<HeaderLabel>File name:</HeaderLabel>
				<HeaderValue>{fileName}</HeaderValue>
				<HeaderHelper>({fileSize})</HeaderHelper>
			</HeaderRow>

			<FileSummary>
				<ImageWrapper>
					<ApIcon iconName="outline_error" iconSize="24px" iconColor={white} />
				</ImageWrapper>
				{rowsWithErrors} conflicted rows found, please update your file and
				upload again
				<FlexAlighRight>
					<DownloadBtn onClick={downloadLog}>Download Log File</DownloadBtn>
				</FlexAlighRight>
			</FileSummary>
			<FileListWrapper>
				<FileList>
					{errors.map((error, index) => (
						<FileItem key={index}>{error}</FileItem>
					))}
				</FileList>
			</FileListWrapper>
		</ErrorTable>
	);
};

ErrorList.propTypes = {
	errors: PropTypes.arrayOf(PropTypes.string),
	fileSize: PropTypes.string,
	fileName: PropTypes.string,
	rowsWithErrors: PropTypes.number,
};

ErrorList.defaultProps = {
	errors: [],
	fileSize: '0',
	fileName: 'FileName',
	rowsWithErrors: 0,
};

export default ErrorList;
